export const PASSWORD_HELP =
    "Shall be at least 8 total characters inclusive of at least 1 number, 1 capital letter, and 1 special character.";
